import { Link } from "react-router-dom";
import { Fragment } from "react/jsx-runtime";
import { NavItem } from "reactstrap";
import { Href } from "../../../../constants";
import { TaskData } from "../../../../data/applications/Task";
import { useAppDispatch, useAppSelector } from "../../../../reduxToolkit/hooks";
import { setActiveTab } from "../../../../reduxToolkit/reducers/taskSlice";
import { NavClassProp } from "../../../../types/Applications";

const TaskViewData: React.FC<NavClassProp> = ({ activeToggle }) => {
  const { activeTab } = useAppSelector((state) => state.task);
  const dispatch = useAppDispatch();
  const tabHandler = (tab: string) => {
    dispatch(setActiveTab(tab));
    activeToggle(tab);
  };

  return (
    <Fragment>
      {TaskData.map((item) => (
        <NavItem key={item.id}>
          <Link to={Href} className={activeTab === item.activeTab ? "active" : ""} onClick={() => tabHandler(item.activeTab)}>
            <span className="title">{item.title}</span>
          </Link>
        </NavItem>
      ))}
    </Fragment>
  );
};
export default TaskViewData;
